export default "__VITE_PUBLIC_ASSET__e5fb0296__"